export default __webpack_public_path__ + "static/media/schedule_call_flower_footer.89894dc0.png";